export default "__VITE_ASSET__ZIVZfxfb__"